import parse from "html-react-parser"
import React from "react"

import * as styles from "../index.module.scss"

export type Props = {
  stringTable: string
}

const BlogHtmlTable = ({ stringTable }: Props) => (
  <div className={styles.tableContainer}>{parse(stringTable)}</div>
)

export default BlogHtmlTable
